import {Component, ElementRef, HostBinding, OnInit, ViewChild} from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  @HostBinding('class.container-fluid') attrClass = true;

  @ViewChild('footerContainerRef') footerContainerRef: ElementRef;
  @ViewChild('bottomPanelRef') bottomPanelRef: ElementRef;

  bottomPanelIsInvisible = false;

  constructor() {}

  ngOnInit() {}
}
